module.exports = __webpack_public_path__ + "assets/img/38b.9344adc4.jpg";